/**
 * QuizStyledCard - Main card component matching quiz page design
 */

import React from "react";
import { Box, BoxProps } from "@mui/material";
import { QUIZ } from "@/theme/quizTokens";

interface QuizStyledCardProps extends BoxProps {
  variant?: "main" | "white" | "sidebar";
  noPadding?: boolean;
}

export function QuizStyledCard({
  variant = "main",
  noPadding = false,
  children,
  sx,
  ...props
}: QuizStyledCardProps) {
  const baseStyles = {
    main: {
      backgroundColor: QUIZ.color.cream,
      borderRadius: { xs: "18px", md: "24px" },
      border: "1px solid rgba(74,48,38,0.1)",
      boxShadow: "0 6px 25px rgba(0, 0, 0, 0.08)",
      padding: noPadding ? 0 : { xs: 2, sm: 3, md: 5 },
    },
    white: {
      backgroundColor: QUIZ.color.warmWhite,
      borderRadius: { xs: "16px", md: "20px" },
      border: "1px solid rgba(0, 0, 0, 0.08)",
      padding: noPadding ? 0 : { xs: 2, sm: 2.5, md: 3 },
      boxShadow: "0px 2px 6px rgba(0,0,0,0.06)",
    },
    sidebar: {
      backgroundColor: QUIZ.color.cream,
      borderRadius: "24px",
      border: "1px solid rgba(74,48,38,0.10)",
      boxShadow: "0 6px 25px rgba(0,0,0,0.05)",
      padding: noPadding ? 0 : { xs: 3, md: 4 },
    },
  };

  return (
    <Box sx={{ ...baseStyles[variant], ...sx }} {...props}>
      {children}
    </Box>
  );
}
